import { APIService } from "../../../../network/api/APIService";

export const SymbolData = ({ method, id = null, formData = {} }) => {
    let endpoint = "/ea/symbol/";

    if ((method === "DELETE") && id) {
        endpoint += `?id=${id}`;
    }

    const config = {
        endpoint: endpoint,
        method: method,
        credentials: "include",
    };

    if (["POST"].includes(method)) {
        config.data = formData;
    }

    return APIService(config);
};